import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {AutomatedReviewComment} from './AutomatedReviewComment'

registerReactPartial('automated-review-comment', {
  Component: AutomatedReviewComment,
})
